module.exports = __webpack_public_path__ + "static/img/kong_.be064cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kong/kong_.png
// module id = qtKd
// module chunks = 1